/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskResponseDto } from './TaskResponseDto';
import {
    TaskResponseDtoFromJSON,
    TaskResponseDtoFromJSONTyped,
    TaskResponseDtoToJSON,
    TaskResponseDtoToJSONTyped,
} from './TaskResponseDto';

/**
 * 
 * @export
 * @interface ListTasksResponseDto
 */
export interface ListTasksResponseDto {
    /**
     * 
     * @type {Array<TaskResponseDto>}
     * @memberof ListTasksResponseDto
     */
    data: Array<TaskResponseDto>;
}

/**
 * Check if a given object implements the ListTasksResponseDto interface.
 */
export function instanceOfListTasksResponseDto(value: object): value is ListTasksResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListTasksResponseDtoFromJSON(json: any): ListTasksResponseDto {
    return ListTasksResponseDtoFromJSONTyped(json, false);
}

export function ListTasksResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTasksResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(TaskResponseDtoFromJSON)),
    };
}

export function ListTasksResponseDtoToJSON(json: any): ListTasksResponseDto {
    return ListTasksResponseDtoToJSONTyped(json, false);
}

export function ListTasksResponseDtoToJSONTyped(value?: ListTasksResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(TaskResponseDtoToJSON)),
    };
}

